import "./insights.scss";
import { useEffect, useState } from "react";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import Card from "react-bootstrap/Card";
import CardGroup from "react-bootstrap/CardGroup";
import InsightBulbIcon from "../../assets/media/icons/insight.png";
import EyeIcon from "../../assets/media/icons/eye.png";
import KebabIcon from "../../assets/media/icons/kebab.png";
import PlusIcon from "../../assets/media/icons/plus.png";
import {
  AIGeneratedCompanyInsight,
  ICompanyRegistrationBasicInfo,
  IWebScrapData,
  Insight,
  companyRegistrationSelector,
} from "../../redux/reducers/company-registration/companyRegistrationSlice";
import {
  Button,
  Col,
  Container,
  Form,
  InputGroup,
  Row,
  Stack,
} from "react-bootstrap";
import { useAppDispatch, useAppSelector } from "../../hooks/typed-hooks";
import {
  ICompanyInsightInfo,
  companyInsightSelector,
} from "../../redux/reducers/company-insight/companyInsightSlice";
import TrowelIcon from "../../components/icon";
// import { useAppDispatch, useAppSelector } from "../../../hooks/typed-hooks";
// import { companyRegistrationSelector, registerCompanyInfo } from "../../../redux/reducers/company-registration/companyRegistrationSlice";

const InsightPage: React.FC = () => {
  const [companyRegistrationInfo, setCompanyRegistrationInfo] = useState<
    ICompanyRegistrationBasicInfo | undefined
  >(undefined);
  const [companyInsightInfo, setCompanyInsightInfo] = useState<
    ICompanyInsightInfo | undefined
  >(undefined);
  const [webscrapDataList, setWebscrapDataList] = useState<
    IWebScrapData<any>[] | undefined
  >(undefined);

  const selectCompnayInfo = useAppSelector(companyRegistrationSelector);
  const selectCompanyInsightInfo = useAppSelector(companyInsightSelector);
  const dispatch = useAppDispatch();

  useEffect(() => {
    console.log(
      "Company registration information after filling company name and website url",
      selectCompnayInfo
    );
    setCompanyRegistrationInfo(selectCompnayInfo);
  }, [selectCompnayInfo]);

  useEffect(() => {
    console.log("Company webscrap information", selectCompanyInsightInfo);
    setCompanyInsightInfo(selectCompanyInsightInfo);
    setWebscrapDataList(selectCompanyInsightInfo.webscrapParseList);
  }, [selectCompanyInsightInfo]);

  const aiGeneratedCompanyInsight: AIGeneratedCompanyInsight = {
    Insights: [
      {
        Title:
          "Your website lacks AI-powered job matching features compared to competitors",
        Details:
          "Incorporating AI into job-candidate matching can revolutionize how candidates and employers connect, ensuring better alignment between skills, roles and organizational needs.",
        QuestionType: ["test"],
      },
      {
        Title:
          "Your platform lacks trust-building content like reviews and testimonials.",
        Details:
          "Showcase testimonials, success stories, and case studies on the homepage.",
        QuestionType: ["test"],
      },
      {
        Title: "Job seekers aren’t engaged due to a lack of career resources.",
        Details:
          "Adding career advice blogs, resume-building tools, and interview preparation guides to Jobsomega.com is an excellent idea to expand its offerings and add value for job seekers.",
        QuestionType: ["test"],
      },
      {
        Title:
          "Your platform lacks trust-building content like reviews and testimonials.",
        Details:
          "Showcase testimonials, success stories, and case studies on the homepage.",
        QuestionType: ["test"],
      },
      {
        Title:
          "Your website lacks AI-powered job matching features compared to competitors",
        Details:
          "Incorporating AI into job-candidate matching can revolutionize how candidates and employers connect, ensuring better alignment between skills, roles and organizational needs.",
        QuestionType: ["test"],
      },
      {
        Title:
          "Your platform lacks trust-building content like reviews and testimonials.",
        Details:
          "Showcase testimonials, success stories, and case studies on the homepage.",
        QuestionType: ["test"],
      },
      {
        Title: "Job seekers aren’t engaged due to a lack of career resources.",
        Details:
          "Adding career advice blogs, resume-building tools, and interview preparation guides to Jobsomega.com is an excellent idea to expand its offerings and add value for job seekers.",
        QuestionType: ["test"],
      },
      {
        Title:
          "Your platform lacks trust-building content like reviews and testimonials.",
        Details:
          "Showcase testimonials, success stories, and case studies on the homepage.",
        QuestionType: ["test"],
      },
      {
        Title:
          "Your website lacks AI-powered job matching features compared to competitors",
        Details:
          "Incorporating AI into job-candidate matching can revolutionize how candidates and employers connect, ensuring better alignment between skills, roles and organizational needs.",
        QuestionType: ["test"],
      },
      {
        Title:
          "Your platform lacks trust-building content like reviews and testimonials.",
        Details:
          "Showcase testimonials, success stories, and case studies on the homepage.",
        QuestionType: ["test"],
      },
      {
        Title: "Job seekers aren’t engaged due to a lack of career resources.",
        Details:
          "Adding career advice blogs, resume-building tools, and interview preparation guides to Jobsomega.com is an excellent idea to expand its offerings and add value for job seekers.",
        QuestionType: ["test"],
      },
      {
        Title:
          "Your platform lacks trust-building content like reviews and testimonials.",
        Details:
          "Showcase testimonials, success stories, and case studies on the homepage.",
        QuestionType: ["test"],
      },
    ],
  };
  const [key, setKey] = useState<any>("profile");

  let improvementRecommendations: string =
    "## Action Plan for Growing Your Cake and Pastry Business This plan addresses your challenges in finding and retaining customers, leveraging your existing technology, and scaling your business nationwide. **Phase 1: Enhancing Customer Acquisition & Retention (3 Months)** **Goal:** Increase customer base by 20% and improve customer retention rate by 15%. **Actionable Steps:** 1. **Refine your Social Media Strategy:** * **Actionable Step 1:** Conduct a social media audit. Analyze which platforms (Facebook, Twitter, Instagram, TikTok – consider adding Instagram and TikTok) perform best. Track engagement rates (likes, comments, shares) and website traffic from each platform. * **Actionable Step 2:** Develop a content calendar focusing on high-quality visuals (professional photos and videos of your cakes and pastries). Showcase the making process, customer testimonials, behind-the-scenes glimpses, and seasonal offerings. Run targeted ads on the best-performing platform(s) focusing on specific demographics (age, location, interests) relevant to small and medium parties. A/B test different ad creatives and targeting options. * **Actionable Step 3:** Engage actively with your followers. Respond promptly to comments and messages. Run contests and giveaways to increase engagement and brand awareness. Use relevant hashtags to improve discoverability. 2. **Implement a Loyalty Program:** * **Actionable Step 1:** Design a loyalty program that rewards repeat customers. This could involve points accumulation for purchases, discounts on future orders, exclusive offers, or birthday treats. * **Actionable Step 2:** Use a loyalty program platform (many affordable options are available) to manage the program efficiently. Promote the program actively on social media and in-store. 3. **Improve Customer Service:** * **Actionable Step 1:** Train your staff on excellent customer service skills. Emphasize friendly interactions, prompt responses to inquiries, and handling complaints effectively. * **Actionable Step 2:** Gather customer feedback through surveys (online or in-person) and reviews (Google My Business, Yelp). Use this feedback to improve your products and services. Respond to online reviews, both positive and negative, professionally. 4. **Explore Local Partnerships:** * **Actionable Step 1:** Collaborate with local event planners, party supply stores, and other businesses that cater to similar clientele. This can lead to referrals and increased visibility. * **Actionable Step 2:** Offer special packages or discounts to these partners to incentivize referrals. 5. **Website Optimization (if you don't have one, create one):** * **Actionable Step 1:** Create a user-friendly website with high-quality images of your products, a clear menu, online ordering capabilities, and contact information. * **Actionable Step 2:** Optimize your website for search engines (SEO) using relevant keywords related to cakes, pastries, and your location. **Phase 2: Expanding Your Reach (6-12 Months)** **Goal:** Open a new outlet and increase brand awareness nationally. **Actionable Steps:** 1. **Market Research:** * **Actionable Step 1:** Conduct thorough market research to identify potential locations for your new outlet. Consider factors like demographics, competition, and rental costs. * **Actionable Step 2:** Analyze the success of your current location. What are the key factors contributing to its success? Replicate those in new locations. 2. **Secure Funding:** * **Actionable Step 1:** Explore funding options, such as small business loans, investors, or crowdfunding. Develop a detailed business plan to present to potential investors. 3. **Develop a National Branding Strategy:** * **Actionable Step 1:** Create a consistent brand identity across all platforms (logo, colors, fonts, messaging). * **Actionable Step 2:** Explore national partnerships (e.g., with event planning companies or catering services) to expand your reach. 4. **Franchise Model (Long-term):** * **Actionable Step 1:** Consider franchising as a long-term growth strategy once you have a proven and scalable business model. **Technology Integration:** * **Point of Sale (POS) System:** Implement a POS system to streamline order taking, payment processing, and inventory management. * **Online Ordering System:** Integrate an online ordering system with your website for ease of ordering and delivery. * **Customer Relationship Management (CRM):** Use a CRM system to manage customer data, track interactions, and personalize marketing efforts. **Measurement & Evaluation:** Regularly track key performance indicators (KPIs) such as website traffic, social media engagement, customer acquisition cost, customer lifetime value, and sales revenue. Use this data to adjust your strategies and optimize your business performance. This plan provides a framework. Adapt it to your specific resources and circumstances. Regular review and adjustment are crucial for success. Remember to celebrate milestones along the way!";

  return (
    <div className="company-insight-container row">
      <span className="h2 text-align-center">
        What we know about your business
      </span>
      <Tabs
        id="controlled-tab-example"
        activeKey={key}
        onSelect={(k) => setKey(k)}
        className="mb-3"
      >
        <Tab eventKey="profile" title="Company Profile">
          <Row className="company-profile-wrapper">
            <Col xs={12} md={6}>
              {/* User provided informations */}
              <Container
                style={{ backgroundColor: "white" }}
                className="company-profile-user-input-container pofile-container"
              >
                <h6>Company Details</h6>

                <div className="info-box">
                  Company Name : {companyRegistrationInfo?.companyName}
                </div>
                <div className="info-box">
                  Company website : {companyRegistrationInfo?.websiteUrl}
                </div>
                <div className="info-box">
                  Business Size : {companyRegistrationInfo?.businessSize}
                </div>
                <div className="info-box">
                  Business Challenge : {companyRegistrationInfo?.challenges}
                </div>
                <div className="info-box">
                  Business Challenge details:{" "}
                  {companyRegistrationInfo?.businessChallengeDescription}
                </div>
                <div className="info-box">
                  Business Type : {companyRegistrationInfo?.businessType}
                </div>
                <div className="info-box">
                  Main Customer : {companyRegistrationInfo?.mainCustomer}
                </div>
                <div className="info-box">
                  Major Service : {companyRegistrationInfo?.mainServices}
                </div>
                <div className="info-box">
                  Major Revenue Generation Service :{" "}
                  {companyRegistrationInfo?.revenueGenService}
                </div>
                <div className="info-box">
                  Technology in Business :{" "}
                  {companyRegistrationInfo?.usageOfTecInBusiness}
                </div>
                <div className="info-box">
                  Vision : {companyRegistrationInfo?.vision}
                </div>
              </Container>
            </Col>
            <Col xs={12} md={6}>
              {/* Webscrapped information */}
              <Container
                style={{ backgroundColor: "white" }}
                className="company-profile-ai-gen-container pofile-container"
              >
                <h6>Information collected from website</h6>
                {webscrapDataList && webscrapDataList.length ? (
                  webscrapDataList.map(
                    (val: IWebScrapData<any>, index: number) => (
                      <div className="info-box" key={index}>
                        <b>{val.key.replace("_", " ").toUpperCase()}</b> :{" "}
                        {val.value.join(", ") || {}}
                      </div>
                    )
                  )
                ) : (
                  <></>
                )}
                <div className="info-box">
                  Company Name : {companyInsightInfo?.answers?.company_name}
                </div>
                <div className="info-box">
                  Contact Number : {companyInsightInfo?.answers?.contact_number}
                </div>
                <div className="info-box">
                  Country : {companyInsightInfo?.answers?.country}
                </div>
                <div className="info-box">
                  Email : {companyInsightInfo?.answers?.email_address}
                </div>
                <div className="info-box">
                  Location : {companyInsightInfo?.answers?.location}
                </div>
                <div className="info-box">
                  Products :{" "}
                  {companyInsightInfo?.answers?.product_details?.join(", ")}
                </div>
                <div className="info-box">
                  Branches : {companyInsightInfo?.answers?.branch_information}
                </div>
                <div className="info-box">
                  Vision : {companyInsightInfo?.answers?.vision}
                </div>
                <div className="info-box">
                  Services : {companyInsightInfo?.answers?.services?.join(", ")}
                </div>
              </Container>
            </Col>
          </Row>
        </Tab>
        <Tab eventKey="insights" title="Insights">
          <Row className="insight-wrapper">
            <Col xs={1} md={7}>
              <Row xs={1} md={1} lg={2} className="g-4">
                {aiGeneratedCompanyInsight.Insights.map(
                  (variant: Insight, index: number) => (
                    <Col key={index}>
                      <Card 
                        bg={"Light"}
                        key={index}
                        text={"dark"}
                        className="md-6 insight-card"
                      >
                        {/* <Card.Header>Header</Card.Header> */}
                        <Card.Body>
                          <Card.Title>
                            <div className="insight-card-top-header">
                              <TrowelIcon src={InsightBulbIcon} />
                              <div className="tag-value">Marketing</div>
                            </div>
                            <div className="insight-title">{variant.Title}</div>
                          </Card.Title>
                          <Card.Text className="insight-details">
                            {variant.Details}
                          </Card.Text>
                          
                        </Card.Body>
                        <Card.Footer>
                        <div className="insight-footer">
                            <div className="flex-default">
                              <div className="icon-container eye-icon-container">
                                <TrowelIcon src={EyeIcon} />
                                <span>View</span>
                              </div>
                              <div className="icon-container">
                                <TrowelIcon src={PlusIcon} />
                                <span>Add</span>
                              </div>
                            </div>
                            <div className="more-menu-icon">
                              <TrowelIcon src={KebabIcon} />
                            </div>
                            
                          </div>
                        </Card.Footer>
                      </Card>
                    </Col>
                  )
                )}
              </Row>
            </Col>
            <Col
              xs={1}
              md={5}
              style={{ backgroundColor: "white" }}
              className="trowel-chat-bot-container"
            >
              <Container fluid="md" className="chat-message-wrapper">
                {/* AI Message */}
                <Row>
                  <Col>
                    <Stack direction="horizontal" className="ai-chat-name">
                      <div className="trowel-icon"></div>
                      <div className="trowel-chat-name">TROWEL.AI</div>
                    </Stack>
                    <Container className="ai-message">
                      Hi, Welcome to trowel.ai chat bot. What are your key
                      objectives for our data analytics solution ?
                    </Container>
                  </Col>
                </Row>

                {/* User Response */}
                <Row>
                  <Col className="user-chat-message-container">
                    <div className="user-chat-name">You</div>
                    <div className="user-chat-message">
                      My key objectives are to gain actionable insights, enhance
                      decision-making, and improve overall efficiency.
                    </div>
                  </Col>
                </Row>

                {/* AI Message */}
                <Row>
                  <Col>
                    <Stack direction="horizontal" className="ai-chat-name">
                      <div className="trowel-icon"></div>
                      <div className="trowel-chat-name">TROWEL.AI</div>
                    </Stack>
                    <Container className="ai-message">
                      How do you measure the success of your marketing efforts ?
                    </Container>
                  </Col>
                </Row>

                <Row className="chat-message-input-wraper">
                  <Col className="chat-message-input-container">
                    <Stack
                      direction="horizontal"
                      className="chat-message-input"
                    >
                      <textarea
                        placeholder="Message"
                        className="text-box col-md-10"
                      />
                      <div className="col-md-2 send-button">Send</div>
                      {/* <InputGroup className="mb-3">
                            <Form.Control
                            placeholder="Recipient's username"
                            aria-label="Recipient's username"
                            aria-describedby="basic-addon2"
                            />
                            <Button variant="outline-secondary" id="button-addon2">
                            Send
                            </Button>
                        </InputGroup>
                        */}
                    </Stack>
                  </Col>
                </Row>
              </Container>
            </Col>
          </Row>
        </Tab>
        <Tab eventKey="recommendations" title="Recommendations">
          <Row className="company-recommendations">
            <Col xs={12} md={12}>
              <div className="ai-recommendation-wrapper">
                {selectCompanyInsightInfo.recommendations}

                {/* Action Plan for Growing Your Cake BusinessThis plan addresses your challenges in finding and retaining customers, ultimately supporting your vision of opening new outlets.  Given your 3-7 years of operation, 11-50 employee size, and focus on B2C cake sales via social media, we'll focus on strategies that leverage your existing strengths and address your weaknesses.**Phase 1: Enhancing Customer Acquisition (Focus: 3 Months)****Goal:** Increase customer acquisition by 20% within the next three months.**Actionable Steps:**1. **Refine your Social Media Strategy:**    * **Targeted Advertising:** Move beyond organic posts. Utilize Facebook and Instagram's targeted advertising features.  Define your ideal customer (demographics, interests, location) and create highly specific ad campaigns. A/B test different ad creatives (images, videos, copy) to optimize performance. Track key metrics (clicks, website visits, conversions).    * **High-Quality Visual Content:** Invest in professional photography and videography of your cakes.  Showcase the artistry and quality. Use Instagram Stories and Reels to create engaging behind-the-scenes content, highlighting the baking process and your team.    * **Influencer Marketing:** Partner with local food bloggers or Instagrammers to review your cakes.  This can significantly expand your reach to a relevant audience.    * **Run Contests and Giveaways:** Generate excitement and engagement by hosting contests and giveaways on social media.  This can increase brand awareness and attract new followers.    * **Social Media Listening:** Monitor social media conversations about your brand and your competitors. Respond to comments and messages promptly and professionally. Address any negative feedback constructively.2. **Improve your Website (if you have one):**    * **Professional Design:** Ensure your website is visually appealing, easy to navigate, and mobile-friendly.    * **Online Ordering:** Implement a seamless online ordering system. This allows customers to place orders conveniently, anytime.    * **High-Quality Images:** Use the same professional photos from your social media on your website.    * **Customer Reviews:** Encourage customers to leave reviews on your website and Google My Business. Positive reviews build trust and credibility.3. **Explore Local Partnerships:**    * **Collaborate with Local Businesses:** Partner with complementary businesses (e.g., coffee shops, florists, event planners) for cross-promotion.    * **Community Events:** Participate in local farmers' markets, food festivals, and community events to showcase your cakes and interact with potential customers directly.4. **Loyalty Program:**    * **Reward Repeat Customers:** Implement a loyalty program to reward repeat customers with discounts, exclusive offers, or free items. This encourages customer retention and repeat business.**Phase 2: Enhancing Customer Retention (Focus: Ongoing)****Goal:** Increase customer retention rate by 15% within the next six months.**Actionable Steps:**1. **Exceptional Customer Service:**    * **Personalized Communication:**  Address customers by name, remember their preferences, and provide personalized recommendations.    * **Prompt and Efficient Service:**  Respond to inquiries quickly and efficiently.  Ensure orders are delivered on time and in perfect condition.    * **Handle Complaints Effectively:**  Address customer complaints promptly and professionally, offering solutions to resolve any issues.2. **Gather Customer Feedback:**    * **Surveys:** Regularly collect customer feedback through surveys or feedback forms.  Use this information to improve your products and services.    * **Reviews:** Actively solicit reviews from satisfied customers.3. **Email Marketing:**    * **Build an Email List:** Collect email addresses from customers and use email marketing to promote new products, special offers, and events.    * **Targeted Campaigns:** Segment your email list based on customer preferences and send targeted campaigns.4. **Develop a Unique Selling Proposition (USP):** What makes your cakes different from your competitors?  Highlight your USP in your marketing materials and customer interactions.  This could be unique flavors, organic ingredients, custom designs, or exceptional customer service.**Phase 3: Preparing for Expansion (Focus: Ongoing)****Goal:**  Lay the groundwork for opening new outlets.**Actionable Steps:**1. **Financial Planning:** Develop a detailed financial plan for opening new outlets, including start-up costs, operating expenses, and projected revenue.2. **Market Research:** Conduct thorough market research to identify suitable locations for new outlets. Consider factors such as demographics, competition, and accessibility.3. **Operational Planning:** Develop operational plans for new outlets, including staffing, inventory management, and supply chain logistics.4. **Branding and Marketing:** Ensure consistent branding and marketing across all outlets.**Technology Considerations:*** **Point of Sale (POS) System:** Invest in a robust POS system to manage orders, inventory, and payments efficiently.* **Customer Relationship Management (CRM) System:**  A CRM system can help you manage customer data, track interactions, and personalize communications.* **Online Ordering Platform:**  As mentioned earlier, a user-friendly online ordering system is crucial for convenience and efficiency.This plan provides a framework.  Regular monitoring and analysis of key performance indicators (KPIs) are crucial for adapting and optimizing your strategies.  Remember to celebrate successes along the way and stay flexible to adjust your approach as needed. */}
              </div>
            </Col>
          </Row>
        </Tab>
      </Tabs>
    </div>
  );
};

export default InsightPage;
